import qs from 'qs';
import { network } from 'services/network';
import { useQuery } from 'react-query';

const queryFn = (params: { fileMetaDataId: number }) => {
    const querystring = qs.stringify(
        { fileMetaDataId: params.fileMetaDataId },
        { addQueryPrefix: true, skipNulls: true },
    );
    const url = `api/bo/getIntegratedScheduleDetails${querystring}`;
    return network.get(url).then((response) => response.data);
};

export const useQueryGetIntegratedScheduleDetails = (params: { fileMetaDataId: number }) => {
    return useQuery<unknown, QueryError>({
        queryKey: ['getIntegratedScheduleDetails', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.fileMetaDataId),
    });
};
